import { cva } from 'class-variance-authority';
import { motion } from 'motion/react';
import { cn } from '../../lib/utils';

const morphingSquareVariants = cva('flex gap-2 items-center justify-center', {
  variants: {
    messagePlacement: {
      bottom: 'flex-col',
      top: 'flex-col-reverse',
      right: 'flex-row',
      left: 'flex-row-reverse',
    },
  },
  defaultVariants: {
    messagePlacement: 'bottom',
  },
});

export function MorphingSquare({
  className,
  message,
  messagePlacement = 'bottom',
  ...props
}) {
  return (
    <div className={cn(morphingSquareVariants({ messagePlacement }))}>
      <motion.div
        className={cn('w-10 h-10 bg-foreground', className)}
        animate={{
          borderRadius: ['6%', '50%', '6%'],
          rotate: [0, 180, 360],
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut',
        }}
        {...props}
      />
      {message && <div>{message}</div>}
    </div>
  );
}
